<div class="sample-data-loading-dialog bpx-dialog" [class.sample-data-loading-dialog--dismissed]="isAnimatingOut" aria-live="polite">
  <mat-spinner diameter="52"></mat-spinner>
  <div class="sample-data-loading-dialog__text">
    <h3>Refreshing sample data</h3>
    <p>The view you're on needs the latest sample rows to stay accurate, so we're pulling them now.</p>
    <p>Feel free to dismiss this message—the fetch will keep running in the background.</p>
  </div>
  <button matRipple type="button" class="bpx-btn bpx-btn--primary" (click)="dismiss()">Dismiss</button>
</div>
